'use client';

import { Provider } from 'jotai';
import { ThemeProvider } from 'next-themes';
import NextTopLoader from 'nextjs-toploader';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <Provider>
        <NextTopLoader
          color="oklch(0.568 0.090 204)"
          height={3}
          showSpinner={false}
          shadow={false}
        />
        {children}
      </Provider>
    </ThemeProvider>
  );
}
